import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { SelectField } from 'redux-form-material-ui';
import * as validator from '../../../../../helpers/Validator';
import MenuItem from 'material-ui/MenuItem';

import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';

let PaymentPreferenceForm = props => {
  const { handleSubmit } = props;

  return (
    <div>
      <form onSubmit={handleSubmit.bind(this)} id="form_field">
        <div style={{ textAlign: 'center', fontSize: '14px' }}>
          You can change your <TenantResidentVerbiageHelper />&#39;s payment preference by selecting
          an option from the dropdown below.
        </div>

        <div className="row">
          <div className="col-xs-12" style={{ textAlign: 'center' }}>
            <div style={{ width: '300px', margin: 'auto', textAlign: 'initial' }}>
              <Field
                name="payment_preference"
                component={SelectField}
                style={{ fontSize: '14px' }}
                validate={[validator.required]}
                floatingLabelText="Payment Preference"
                fullWidth
              >
                <MenuItem value="Cash" primaryText="Cash" />
                <MenuItem value="Credit Card" primaryText="Credit Card" />
                <MenuItem value="eTransfer" primaryText="eTransfer" />
                <MenuItem value="Post Dated Cheques" primaryText="Post Dated Cheques" />
                <MenuItem value="Pre-Auth Debit" primaryText="Pre-Auth Debit" />
              </Field>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

PaymentPreferenceForm = reduxForm({
  form: 'payment_preference_form', // a unique identifier for this form
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
})(PaymentPreferenceForm);

export default PaymentPreferenceForm;
